import { Navigate, useLocation } from "react-router-dom";
/**
 *
 * @returns :Trả về jsx theo Role của người đăng nhập
 */
export const Authorization = (): JSX.Element => {
  let authorizationData = JSON.parse(localStorage.getItem("authorizationData"));
  if (authorizationData) {
    switch (authorizationData.Role) {
      case "SV":
        return <Navigate to="/student" />;
      case "CSV":
        return <Navigate to="/student" />;
      case "GV":
        return <Navigate to="/professor" />;
        break;
      case "NV":
        return <Navigate to="/staff" />;
      case "AD":
        return <Navigate to="/staff" />;
      default:
        return <Navigate to="*" />;
    }
  }
};
/**
 *
 * @returns Kiểm tra Auth routing
 */
export const AuthorizationRouting = (): JSX.Element => {
  let authorizationData = JSON.parse(localStorage.getItem("authorizationData"));
  if (authorizationData) {
    let currentlocation = useLocation().pathname.toString();
    switch (authorizationData.Role) {
      case "SV": {
        let indexlocation = currentlocation.indexOf("/student");
        if (indexlocation == 0) {
          return <Navigate to="/student" />;
        }
        return <Navigate to="/404" />;
      }
      case "GV": {
        let indexlocation = currentlocation.indexOf("/professor");
        if (indexlocation == 0) {
          return <Navigate to="/professor" />;
        }
        return <Navigate to="/404" />;
      }
      case "NV": {
        let indexlocation = currentlocation.indexOf("/staff");
        if (indexlocation == 0) {
          return <Navigate to="/staff" />;
        }
        return <Navigate to="/404" />;
      }
      default:
        return <Navigate to="*" />;
    }
  }
};
export const AuthenrizationRoutingRole = (): JSX.Element => {
  let AuthMenu = JSON.parse(localStorage.getItem("AuthMenu"));
  let currentlocation = useLocation().pathname.toString();
  let AuthRoutes = [];
  if (AuthMenu) {
    AuthMenu.map((el) => {
      el.items.map((item) => {
        AuthRoutes.push(item.path);
      });
    });
    console.log(AuthRoutes);
  }
  return <Navigate to="/staff" />;
};
